import firebase from 'firebase'
import "@firebase/auth";
import store from "../store/index.js";

const firebaseConfig = {
    apiKey: "AIzaSyB8q9AzC2bZFZ8X9sc7u003hWCq-o-uq8s",
    authDomain: "enishi-dev.firebaseapp.com",
    databaseURL: "https://enishi-dev.firebaseio.com",
    projectId: "enishi-dev",
    storageBucket: "enishi-dev.appspot.com",
    messagingSenderId: "320502398156",
    appId: "1:320502398156:web:53064e99114580c1039669",
    measurementId: "G-606VCN7352"
};

export default {
    init() {
        firebase.initializeApp(firebaseConfig);
        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
    },
    login() {
        const provider = new firebase.auth.GoogleAuthProvider();
//        firebase.auth().signInWithRedirect(provider)
        firebase.auth().signInWithPopup(provider)
    },
    logout() {
        firebase.auth().signOut()
    },
    onAuth() {
        firebase.auth().onAuthStateChanged(user => {
            user = user ? user : {};
            store.commit('onAuthStateChanged', user);
            store.commit('onUserStatusChanged', user.uid ? true : false);
            store.commit('checkAuth');
        });
    }
};
